import React, { useContext, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import { CheckCircle, AddCircle } from "@material-ui/icons";
import {
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Grid,
  Typography,
} from "@material-ui/core";

import { removeAfterDash, mapIdToPrice } from "../../helpers";
import { OrderContext } from "../../context";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  addCircle: {
    color: theme.palette.secondary.light,
  },
  checkCircle: {
    color: theme.palette.action.main,
  },
}));

export default function CheckboxList(props) {
  const { orders, setOrders } = useContext(OrderContext);
  const [clicked, setClicked] = useState(null);
  const classes = useStyles();
  const handleClick = (event, id, name) => {
    const nextOrdersState = [...orders];
    const findIdx = nextOrdersState.findIndex(
      (item) => String(item.id) === String(id)
    );
    if (findIdx === -1) {
      nextOrdersState.push({
        id: id,
        name: removeAfterDash(name),
        quantity: 1,
        price: mapIdToPrice(props.subitems, id),
      });
    } else {
      nextOrdersState[findIdx].quantity += 1;
    }
    setOrders(nextOrdersState);
    setClicked(id);
  };

  useEffect(() => {
    if (clicked) {
      setTimeout(() => {
        setClicked(null);
      }, 2000);
    }
  }, [clicked]);

  return (
    <FormGroup className={classes.root}>
      <Grid container direction="column" justify="center" spacing={3}>
        {props.subitems.map((sub) => {
          const labelId = [props.mainName, sub.subname].join(" ");
          const id = String(sub.id);

          return (
            <Grid
              key={labelId}
              item
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              onClick={(e) => handleClick(e, id, labelId)}
            >
              <Grid
                item
                xs={1}
                container
                justify="flex-start"
                alignContent="center"
              >
                <IconButton edge="start">
                  {clicked === id ? (
                    <CheckCircle className={classes.checkCircle} />
                  ) : (
                    <AddCircle className={classes.addCircle} />
                  )}
                </IconButton>
              </Grid>
              <Grid
                item
                xs={9}
                container
                justify="flex-start"
                alignContent="center"
              >
                <Typography>
                  <b>[{sub.id}]</b> {sub.subname || props.mainName}
                </Typography>
              </Grid>
              <Grid
                item
                xs={1}
                container
                justify="flex-end"
                alignContent="center"
              >
                <Typography>{sub.price}&euro;</Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </FormGroup>
  );
}
